<!--
 * @Desc: 页脚
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-08 09:21:54
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-footer">
        <div class="container">
            <div class="info">
                <ul class="info-list">
                    <!-- <li>关于我们</li>
                    <li>|</li> -->
                    <li @click="$toPath('/Link',{active:-1})">友情链接</li>
                    <!-- <li>|</li>
                    <li>恒源地图</li> -->
                    <li>|</li>
                    <li @click="$toPath('/contact',{active:-1})">意见反馈</li>
                </ul>
                <div class="contact">
                    联系我们：{{ configData.phone }}
                </div>
                <div class="adress">
                    地址：{{ configData.address }}  邮编：{{ configData.youbian }} <span>|</span> <img style="vertical-align: middle;margin-right: 8px;" src="../../../public/statics/images/Footer/icon-beian.png"><a target="_blank" :href="configData.beian_url">{{ configData.beian_title }}</a>
                </div>
            </div>
            <div class="code-pic">
                <img v-if="configData.qrcode" style="width:85px;height:85px;" :src="$adddom(configData.qrcode)">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            configData:''
        };
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {
        this.getConfig()
    },
    methods: {
        // 获取网址信息配置
        getConfig(){
            let that = this
            this.$api.index
                .getConfig({})
                .then((res) => {
                    that.configData = res.result
                })
                .catch((res) => {
                    console.log(res)
                });
        }
    },
};
</script>

<style scoped>
.page-footer {
    min-width: 1200px;
    width: 100%;
    height: 170px;
    background: linear-gradient(180deg, #0d1726 0%, #0d1226 100%);
    display: flex;
    align-items: center;
}
.page-footer .container{
    display: flex;
    align-items: center;
}
.page-footer .container .info{
    flex: 1;
}
.page-footer .container .info .info-list{
    display: flex;
}
.page-footer .container .info .info-list li {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255,255,255,0.5);
 }
 .page-footer .container .info .info-list li:nth-child(2n) {
    margin: 0 16px;
 }
.page-footer .container .info .contact{
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255,255,255,0.5);
    margin-top: 22px;
    margin-bottom: 15px;
}
.page-footer .container .info .adress{
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255,255,255,0.5);
    display: flex;
    align-items: center;
}
.page-footer .container .info .adress span{
    margin: 0 15px;
}
.page-footer .container .info .adress a{
    color: rgba(255,255,255,0.5);
}
</style>
